var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "textarea",
    class: {
      greenMode: _vm.greenMode,
      composite: _vm.composite
    },
    attrs: {
      "data-type": "textarea"
    },
    on: {
      "click": _vm.onCopy
    }
  }, [_c('textarea', {
    class: {
      invalid: _vm.$v.$error
    },
    style: _vm.computedStyles,
    attrs: {
      "id": _vm.inputId,
      "rows": _vm.rows,
      "readonly": _vm.readonly,
      "title": _vm.inputTitle,
      "placeholder": _vm.inputPlaceholder,
      "maxlength": _vm.maxLength
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "input": _vm.onInput,
      "focus": _vm.onResize,
      "keydown": _vm.keyDownEventHadler,
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('click');
      }
    }
  }), _c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.inputName) + " ")]), _vm.showCounter ? _c('span', [_vm._v(" " + _vm._s(_vm.counter) + " ")]) : _vm._e(), _vm.$v.$error ? _c('span', {
    staticClass: "validation",
    attrs: {
      "title": _vm.getValidationInfo(_vm.$v)
    }
  }, [_c('mark')]) : _vm._e(), _vm.capustaInfo ? _c('a', {
    staticClass: "hint",
    on: {
      "click": function click($event) {
        return _vm.$showInfo(_vm.capustaInfo);
      }
    }
  }) : _vm._e(), _vm.greenMode ? _c('a', {
    staticClass: "copy copy-fullsize",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('copy.link')) + " ")]) : _vm._e()]), _vm._t("link")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }